/**
 * Strips "Choose" from Bold Product Options line-item property dropdown placeholders.
 * Prefer setting the placeholder text in the Bold app when possible.
 */
(function () {
  var CHOOSE_PATTERN = /--\s*Choose\s+/i;
  var REPLACE_WITH = '-- ';

  function fixPropertySelects(root) {
    var container = root && root.querySelectorAll ? root : document;
    var selects = container.querySelectorAll
      ? container.querySelectorAll('select[name^="properties["]')
      : [];

    for (var i = 0; i < selects.length; i++) {
      var options = selects[i].querySelectorAll('option[value=""]');
      for (var j = 0; j < options.length; j++) {
        var opt = options[j];
        var t = opt.textContent || opt.innerText;
        if (t) {
          var next = t.replace(CHOOSE_PATTERN, REPLACE_WITH);
          if (next !== t) {
            opt.textContent = next;
          }
        }
      }
    }
  }

  var rafId = 0;
  function scheduleRun() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      fixPropertySelects(document);
    });
  }

  function onReady() {
    fixPropertySelects(document);
    if (window.__boldPropertyPlaceholderMO) return;
    var mo = new MutationObserver(function () {
      scheduleRun();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window.__boldPropertyPlaceholderMO = mo;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) {
      fixPropertySelects(ev.target);
    } else {
      fixPropertySelects(document);
    }
  });
})();
